import { useMemo } from 'react';
import { useFetchMyProfileQuery } from '@api/Trinium/Endpoints/myProfile';
import { Terminal } from '@api/Trinium/types';

/**
 * Hook used for accessing User Terminals to simplify finding the default, etc.
 */
export default function useUserTerminals() {
	const { data, isLoading } = useFetchMyProfileQuery(undefined);

	const defaultTerminal = useMemo(() => {
		if (!isLoading && data) {
			// There is nothing ensuring we have a single default, or a default at all so need to check that at least one is there.
			const filteredArray = data.terminals.filter((terminal) => terminal.isDefault);
			return filteredArray.length > 0 ? filteredArray[0] : null;
		}
		return null;
	}, [data, isLoading]);

	const terminalsByName = useMemo(() => {
		if (!data?.terminals) {
			return [] as Terminal[];
		}
		const copy = [...data.terminals];
		return copy.sort((left, right) => left.name.localeCompare(right.name, 'en', { sensitivity: 'base' }));
	}, [data]);

	return {
		defaultTerminal,
		/** Default terminal collection, sorted by Number from the API */
		terminals: data?.terminals ?? [],
		/** Terminal collection sorted by Name */
		terminalsByName: terminalsByName,
		isLoading
	};
}
